import React from 'react';
import {
  formatSalesGoalCounter,
  formatSalesGoalRange,
  type CommercialSalesGoalSnapshot,
} from '../../../utils/salesGoalCounter';
import styles from './SalesGoalCounter.module.css';

interface SalesGoalCounterProps {
  snapshot: CommercialSalesGoalSnapshot | null;
  loading: boolean;
  error: string | null;
}

const SalesGoalCounter: React.FC<SalesGoalCounterProps> = ({ snapshot, loading, error }) => {
  if (loading && !snapshot) {
    return <p className={styles.status}>Carregando meta de vendas...</p>;
  }

  if (error || !snapshot) {
    return <p className={styles.status}>{error ?? 'Não foi possível carregar a meta de vendas.'}</p>;
  }

  const range = formatSalesGoalRange(snapshot.startsOn, snapshot.endsOn);

  return (
    <div className={styles.counter}>
      <span className={styles.value}>
        {formatSalesGoalCounter(snapshot.salesCount, snapshot.targetSales)}
      </span>
      {range && <span className={styles.range}>{range}</span>}
    </div>
  );
};

export default SalesGoalCounter;
